import React from "react";
import { useAuth } from "@/context/AuthContext";

import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";

import { Ban, LogOut, ShieldAlert } from "lucide-react";

const NoAccessPage: React.FC = () => {
    const { logout } = useAuth();

    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-muted/20 px-4">
            <Card className="w-full max-w-md">
                <CardContent className="p-6 space-y-5 text-center">
                    {/* Icon */}
                    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border bg-muted/40">
                        <ShieldAlert className="h-6 w-6 text-destructive" />
                    </div>

                    {/* Title */}
                    <div className="space-y-1">
                        <h1 className="text-xl font-semibold tracking-tight">
                            Нет доступа
                        </h1>
                        <p className="text-sm text-muted-foreground">
                            У вас недостаточно прав для просмотра этой страницы
                        </p>
                    </div>

                    <Separator />

                    {/* Info */}
                    <div className="space-y-2">
                        <Badge variant="destructive" className="rounded-full">
                            Доступ запрещён
                        </Badge>

                        <p className="text-sm text-muted-foreground">
                            Обратитесь к администратору, если считаете, что это ошибка
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="pt-2">
                        <Button
                            variant="destructive"
                            className="w-full"
                            onClick={logout}
                        >
                            <LogOut className="h-4 w-4 mr-2" />
                            Выйти из аккаунта
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default NoAccessPage;
